<template>
    <fade-loader v-bind="fadeLoader">
        <div v-if="fieldLayoutConfig" class="toolbox-content">
            <div v-for="fieldSettings in fieldLayoutConfig" :key="fieldSettings.handle">
                <component
                        :block-type-name="fieldSettings.blockTypeName"
                        :default="fieldSettings.default"
                        :field-type="fieldSettings.type"
                        :handle="fieldSettings.handle"
                        :instructions="fieldSettings.instructions"
                        :error-messages="errors"
                        :error="isError(fieldSettings.handle)"
                        :field-layout-id="fieldSettings.fieldLayoutId"
                        :fields="fieldSettings.fields"
                        :is="getFieldComponent(fieldSettings)"
                        :label="fieldSettings.label"
                        :sub-label="fieldSettings.subLabel"
                        :loading="loading"
                        :limit="fieldSettings.limit"
                        :items="fieldSettings.options"
                        :readonly="getIsReadOnly(fieldSettings)"
                        :restrictedFiles="fieldSettings.restrictedFiles"
                        :suffix="fieldSettings.suffix"
                        v-model="value[fieldSettings.handle].value"
                ></component>
            </div>
            <span v-if="value.lastEditor !== null" class="note">
                Letzte Bearbeitung {{ value.dateUpdated|date() }} durch {{value.lastEditor}}
            </span>
        </div>
    </fade-loader>
</template>

<script>
  import moment from 'moment'
  import LayerAPI from '@/api/layer'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        required: false
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        realFieldLayoutConfig: null
      }
    },
    async mounted () {
      let results = null
      try {
        results = await this.$resolve([LayerAPI.getFieldLayout(this.value.fieldLayoutId, true), this.value.loadingPromise])
      } catch (e) {
        return
      }
      this.realFieldLayoutConfig = results[0].data
    },
    filters: {
      date (value, format = 'DD.MM.YYYY - HH:mm') {
        /** @var {moment.Moment} localMoment */
        let localMoment = null
        if (moment.isMoment(value)) {
          localMoment = value
        }

        if (typeof value === 'number') {
          localMoment = moment.unix(value)
        }

        if (typeof value === 'string') {
          localMoment = moment(value)
        }

        if (localMoment !== null && moment.isMoment(localMoment)) {
          return localMoment.format(format)
        }

        return ''
      }
    },
    computed: {
      fieldLayoutConfig () {
        let realConfig = this.flatFieldLayoutConfig
        let config = []
        for (let i = 0; i < this.value.previewFieldLayout.length; i++) {
          if (!realConfig[this.value.previewFieldLayout[i].mapping]) {
            continue
          }
          let tempConfig = { ...realConfig[this.value.previewFieldLayout[i].mapping] }

          if (this.value.previewFieldLayout[i].fields) {
            // matrix fields
            for (let key in this.value.previewFieldLayout[i].fields) {
              if (tempConfig.fields[key]) {
                tempConfig.fields[key].required = this.value.previewFieldLayout[i].fields[key].required
              }
            }
          }

          tempConfig.readonly = tempConfig.readonly || this.value.previewFieldLayout[i].readonly
          tempConfig.required = tempConfig.required || this.value.previewFieldLayout[i].required
          if (this.value.previewFieldLayout[i].label !== tempConfig.label) {
            tempConfig.subLabel = tempConfig.label
            tempConfig.label = this.value.previewFieldLayout[i].label
          }
          config.push(tempConfig)
        }

        return config
      },
      flatFieldLayoutConfig () {
        if (!this.realFieldLayoutConfig) {
          return {}
        }
        let config = {}

        for (let tabName in this.realFieldLayoutConfig) {
          if (!this.realFieldLayoutConfig.hasOwnProperty(tabName)) {
            continue
          }
          for (let i = 0; i < this.realFieldLayoutConfig[tabName].length; i++) {
            if (tabName === 'immoscout_fields') {
              let temp = { ...this.realFieldLayoutConfig[tabName][i] }
              temp.handle = 'field_immoscout_' + temp.handle.replace('field_', '')
              config[temp.handle] = temp
              continue
            }
            config[this.realFieldLayoutConfig[tabName][i].handle] = this.realFieldLayoutConfig[tabName][i]
          }
        }

        return config
      },
      getFieldComponent () {
        return (settings) => {
          switch (settings.type) {
            case 'craft\\fields\\Assets':
              if (settings.allowedKinds && settings.allowedKinds.indexOf('image') > -1 && settings.allowedKinds.length === 1) {
                if (settings.limit === '1') {
                  return 'image-upload'
                }

                return 'gallery-input'
              }

              return 'file-upload'
            case 'craft\\fields\\PlainText':
              if (settings.multiline) {
                return 'text-area'
              }
              return 'text-field'
            case 'craft\\fields\\Categories':
            case 'modules\\raumkarte\\fields\\Categories':
            case 'craft\\fields\\Dropdown':
              return 'dropdown'
            case 'craft\\fields\\Number':
              return 'text-field'
            case 'craft\\fields\\Matrix':
              return 'matrix'
            case 'craft\\fields\\Lightswitch':
              return 'lightswitch'
            case 'craft\\fields\\Date':
              return 'date'
          }
        }
      },
      getIsReadOnly () {
        return (fieldSettings) => this.readOnly || this.value.readonly || fieldSettings.readonly
      },
      isError () {
        return (prop) => {
          let realHandle = prop.replace('field_', '')
          return this.errors && typeof this.errors[realHandle] !== 'undefined'
        }
      }
    }
  }
</script>

<style scoped>

</style>
